import type { SxProps, Theme } from '@mui/material';
import { alpha } from '@mui/material/styles';

/**
 * Editable input field styles (theme-aware for light/dark mode)
 */
export function getEditableInputSx(theme: Theme): SxProps<Theme> {
  return {
    '& .MuiOutlinedInput-root': {
      borderRadius: 2,
      bgcolor:
        theme.palette.mode === 'dark'
          ? alpha(theme.palette.common.white, 0.05)
          : alpha(theme.palette.common.black, 0.02),
      '& fieldset': { borderColor: 'divider' },
      '&:hover fieldset': { borderColor: 'primary.main' },
      '&.Mui-focused fieldset': {
        borderColor: 'primary.main',
        borderWidth: 2,
      },
    },
  };
}

/**
 * Disabled/read-only input field styles
 */
export const disabledInputSx: SxProps<Theme> = {
  '& .MuiOutlinedInput-root': {
    borderRadius: 2,
    bgcolor: 'action.hover',
    '& fieldset': { borderColor: 'divider' },
  },
};

/**
 * Form label styles
 */
export const formLabelSx: SxProps<Theme> = {
  fontSize: '0.8125rem',
  fontWeight: 600,
  mb: 0.5,
  color: 'text.secondary',
};

/**
 * Form caption/helper text styles
 */
export const formCaptionSx: SxProps<Theme> = {
  mt: -1,
  display: 'block',
  color: 'text.disabled',
  fontSize: '0.75rem',
};

/**
 * Action button styles (outlined, full-width form actions)
 */
export const actionButtonSx: SxProps<Theme> = {
  py: 1.5,
  borderRadius: 2,
  fontWeight: 600,
  textTransform: 'none',
  fontSize: '1rem',
};
